// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/scribe/svc_registry.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { RegistryAsset, RegistryAssetFamily, RegistrySourceKind } from "../../model/dto_scribe_catalog_pb.js";

/**
 * @generated from message com.diagnocat.scribe.ListRegistryAssetsReq
 */
export const ListRegistryAssetsReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListRegistryAssetsReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Family", kind: "enum", T: proto3.getEnumType(RegistryAssetFamily), opt: true },
    { no: 3, name: "SourceKind", kind: "enum", T: proto3.getEnumType(RegistrySourceKind), opt: true },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Query", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 100, name: "Offset", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListRegistryAssetsResp
 */
export const ListRegistryAssetsResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListRegistryAssetsResp",
  () => [
    { no: 1, name: "Assets", kind: "message", T: RegistryAsset, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "AvailableLanguages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

